import React from 'react'
import { useTranslation } from 'react-i18next'
import { RewardsProduct } from 'types/rewards'
import { WithdrawSource } from '../../types'
import { RewardsAmountInput } from './RewardsAmountInput'
import { RewardsCurrencySelect } from './RewardsCurrencySelect'
import { RewardsWalletSelect } from './RewardsWalletSelect'
import { RewardsWithdrawSourceRadio } from './RewardsWithdrawSourceRadio'

interface RewardsWithdrawFormFieldsProps {
  isRemoveAllocation: boolean
  isCustomerRewards: boolean
  isPending: boolean
  selectedCurrency: string
  portfolioCurrency: string | null
  rewardsProducts: RewardsProduct[]
  withdrawSource: WithdrawSource
  maxAmount: string
  onMaxAmountChange: (amount: string) => void
}

export const RewardsWithdrawFormFields = ({
  isRemoveAllocation,
  isCustomerRewards,
  isPending,
  selectedCurrency,
  portfolioCurrency,
  rewardsProducts,
  withdrawSource,
  maxAmount,
  onMaxAmountChange,
}: RewardsWithdrawFormFieldsProps) => {
  const { t } = useTranslation()

  return (
    <>
      {isCustomerRewards && !isRemoveAllocation && (
        <RewardsWithdrawSourceRadio disabled={isPending} testId="withdraw-source-radio" />
      )}

      {rewardsProducts.length > 1 && (
        <RewardsCurrencySelect
          selectedCurrency={selectedCurrency}
          disabled={!!portfolioCurrency || isPending}
          filterByBalance={isRemoveAllocation ? 'blocked' : undefined}
          setMaxAmount={onMaxAmountChange}
        />
      )}

      <RewardsWalletSelect
        selectedCurrency={selectedCurrency}
        name="withdrawToWallet"
        label={
          isRemoveAllocation
            ? t('rewards.removeAllocation.sendBackToWallet')
            : t('rewards.withdraw.withdrawToWallet')
        }
        disabled={!selectedCurrency || isPending}
        testId="withdraw-to-wallet-combobox"
      />

      <RewardsAmountInput
        selectedCurrency={selectedCurrency}
        maxAmount={maxAmount}
        disabled={!selectedCurrency || isPending || withdrawSource === 'customerRewards'}
        label={isRemoveAllocation ? t('rewards.removeAllocation.amountToRemove') : t('amount')}
        hideMaxButton={withdrawSource === 'customerRewards'}
      />
    </>
  )
}
